import { onError } from '@apollo/client/link/error';
import { ServerError } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { ERRORS_TO_TRACK_IN_SENTRY, globalErrorHandler, isThrottlingError } from '../../globalErrorHandler';

export const globalErrorHandlerMiddleware = onError(({ graphQLErrors, networkError }) => {
  if ((networkError as ServerError)?.statusCode && (networkError as ServerError).statusCode !== 200) {
    Sentry.captureException(networkError);
  }

  graphQLErrors?.forEach(({ extensions }) => {
    const code = extensions?.code;
    const exceptionCode = extensions?.exception?.code;
    if (ERRORS_TO_TRACK_IN_SENTRY.includes(code)) {
      Sentry.captureMessage(`${code} occurred`);
    }

    if (isThrottlingError(exceptionCode)) {
      globalErrorHandler.showRateLimitedSnackbar();
    }
  });
});
